export default "__VITE_ASSET__4637fd22__"